import React, { ReactNode } from "react";
import { Card, Collapse } from "react-bootstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";

//ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
interface ICollapseCard {
	header: ReactNode;
	body: ReactNode;
	id: string;
	className: string;
	state: boolean;	// true: visible/uncollapsed, false: collapsed
	collapsible: boolean;
	onFinishAnimation?: () => void,
	onChangeState?: () => void,
}

export const CollapseCard = (props: ICollapseCard) => {

	const click = () => {
		props.onChangeState();
	};

	if (props.collapsible) {
		return (
			<Card id={props.id} className={props.className} >
				<Card.Header className="d-flex justify-content-between" onClick={click}>
					{props.header}
					<a className="text-dark" onClick={click}>
						{props.state ?  <FontAwesomeIcon size="lg" icon={faChevronUp} /> :   <FontAwesomeIcon size="lg" icon={faChevronDown} /> }
					</a>
				</Card.Header>
				<Collapse in={props.state} onEntered={props.onFinishAnimation} onExited={props.onFinishAnimation}>
					<Card.Body>
						{props.body}
					</Card.Body>
				</Collapse>
			</Card>
		);
	} else {
		return (
			<Card id={props.id} className={props.className} >
				<Card.Header>{props.header}</Card.Header>
				<Card.Body>{props.body}</Card.Body>
			</Card>
		);
	}
};

export default CollapseCard;
